var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _line169, _line170, _line171, _line172;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPls1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.5 187.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#812990;}.cls-2{fill:#6b7b84;}.cls-3{fill:#231f20;}.cls-4,.cls-5,.cls-6,.cls-7{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-5{stroke-dasharray:2.02 2.02;}.cls-6{stroke-dasharray:1.98 1.98;}.cls-7{stroke-dasharray:1.98 1.98;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.57,107.55l-2.76.39a8.86,8.86,0,0,1-1.36.3c-1.06-.06-1.61-1.33-3.09-1.63-.36-.06,0,.06-.54-.18-.73-.3.18-.09-.7-.33,0,1-.21.69-.21,1.45a5.59,5.59,0,0,0,.6,2.5c.27.54.4.36.37,1.15,0,1.48-.22,1.9.42,3.14a8.1,8.1,0,0,1,1.09,2.23c1.45,0,1.24-.06,1.42.42,1.37,0,.49-.3,1.25-.42.06,0,1.39.33,1-1.42,1,.27.54.82,1.21.76s.27-.52.36-1.15-.27-.18.7-.63l-.21-1.24c0-1.45.33,0,.81.21l.61-4.35c.06-.33.45-.18-.39-1.42C104.24,107.45,104.78,107.48,104.57,107.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105,103.86c-.15.58.34.33-.39.39l.82,1.85c.36-.19.24-.16.81-.19,0-1.26,0-.81-.42-1.44C105.51,104.1,105.51,104,105,103.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.66,102.2c-.21.85-.06,0-.27.67-.33,1-.36,1.84.88,1.17C95.27,102.59,95.42,102.72,94.66,102.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.79,87.62a7.6,7.6,0,0,0-2.51.39c-1.51.4-.85.73-.36,1.45,2.87,0,1.93-.24,3.57-.51.67-.12.73.09.33-.72h-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.5,77.52c0-.24-.12-.47-.19-.7L118,76c-1.68-.62-3.35-1.25-5-1.9-1.45-.59-3.36-1.38-5.24-2.31a68.4,68.4,0,0,1-6.08-3.31,13.9,13.9,0,0,1-5-5.67,17.09,17.09,0,0,1-1.12-2.85l-.4,0a10.9,10.9,0,0,0-2.26.3c-.72.16-1.43.35-2.14.54A26.89,26.89,0,0,1,85,61.82l-.75,0c-.72,0-1.45.08-2.17.08s-1.13,0-1.64-.08A32.08,32.08,0,0,1,77,61.25L75.77,61c-.3.37-.61.73-.93,1.1a2.88,2.88,0,0,1,.63.58,4.14,4.14,0,0,1,.86,4,6.19,6.19,0,0,1-5.38,4c-.68,0-1.32,0-2-.08l-.33,0a6.6,6.6,0,0,1-5.3-3.47,4.7,4.7,0,0,1,.38-5.16l.11-.16c.27-.43.56-.85.86-1.28a14.7,14.7,0,0,0,1-1.5c.18-.36.36-.73.53-1.1a7,7,0,0,1-5.93-4.47,14.49,14.49,0,0,1-.91-4.3l-.6.15-.95.24a7.48,7.48,0,0,1-.82.89,5.2,5.2,0,0,1-3.66,1.72,4.86,4.86,0,0,1-1.44-.23h-.24A4.72,4.72,0,0,1,48.92,51,3.5,3.5,0,0,1,47.37,50a3.58,3.58,0,0,1-.69-3.06A13.12,13.12,0,0,1,49,41.8l.29-.4a4.75,4.75,0,0,1,1.42-2.91c.63-.62,1.26-1.16,1.87-1.68l.51-.43a13,13,0,0,1,1-.81,6.29,6.29,0,0,1,1-2.73,11.45,11.45,0,0,1,3.4-3.31c.71-.46,1.42-.85,2.1-1.22l1-.58,1-.59.54-.34a3.15,3.15,0,0,1,3-.17,3.23,3.23,0,0,1,1.78,3.72s-.78,2.71-1,3.59a8.39,8.39,0,0,1-1.51,2.86,25.9,25.9,0,0,1,2.22,1.51A14.1,14.1,0,0,1,69.35,40h1.33a2.91,2.91,0,0,0,.47-.08,11.25,11.25,0,0,0,3.26-1.49l.47-.27a28.16,28.16,0,0,1,6.41-3.06,44.15,44.15,0,0,1,11.39-1.6h1.5c2.11,0,4.22.1,6.18.21a36.7,36.7,0,0,1,4.73.64,27.69,27.69,0,0,1,11.38,4.94,2.11,2.11,0,0,0-1.12-1.58c-.6-.27-.3.06-.72-.36,0,0-.07-.06-.1-.09l-.45-.37c-.73-.45-.61.13-.88-1l-.27.15a.43.43,0,0,0-.12.06c-.46.12-.31-.81-.73-1.33s.18.39-.88-.15c-.57-.27,0,0-.33-.24a.88.88,0,0,0-.43-.21l-.36-.09c-1.69-.7-1.39-1-1.39-2.69-1.46-.39-.58-1.51-.49-2.44.19-1.51-.72-1.7-.36-3.33-2,0-1.21-2-1.79-4.19l-.09-2c.09-.43,0,.18.24-.58l-.54-.27c-1.94-1.15-1.54-2.05-2.12-2.41l-1.42.45c-.43.3,0,.21-.64.36-1.36-1.27-.73-3.92-1.18-5.61-.18-.73-.33-1.73-1.3-2a3.14,3.14,0,0,1,.6-1.23c-.48-.25-.73-.19-1.21-.43a5.89,5.89,0,0,0-.64-3.29c-.39-.66-.12-.72-1-.81-.24,1-.15.39-1,.81a5.81,5.81,0,0,1-.75,3.17s-.06.09-.06.12L94.69,8a4.08,4.08,0,0,0-.84,2h.6c-.06.93-.06.39-.45,1-.55.82-.24-.06-.12,1s-.73,1.15-.64,2.29c.06.76.33.52.3,1.24,0,.42-.21.61-.18,1.18.06,1.54.64,1.15-.06,2.63s-.45,3-1.39,4.55a18.93,18.93,0,0,0-1.06,2.24,3,3,0,0,1-2.33.9,9.37,9.37,0,0,1-2.09-1c-.4-.21-.7-.34-.88-.73s-.06-.27-.24-.6c-.49-1-1.85-.94-2.82-1.3s-1.33-1.75-3.7-2.69l-1.24-.39s-.91-.6-1-.66l-.79-.88c-.24-.21-.66-.45-1-.69L74,17.49c-.82-.45-.7,0-.73-1.14.45-.15,1-1,1.36-1.54.25-.3.06,0,.25-.36L75,14s0-.09.06-.12c.12-.3.3-.75.42-1-.85-.34,0,.15-.82-.22.34-.48.25-.21.43-.81,1.06-.51.79-.21,1.42,0,1.24-1.81.52-.67.79-1.72.24-.88.85-1.09,1.27-1.75l-.76-.49c-.84-.45-.66.34-.66-1.17a3.87,3.87,0,0,0-1.67,1.23c-.21-.27-.21.43-.21-.6a3.12,3.12,0,0,1-1,.39c.61-.78.33,0,.64-.81-1.4.33-1.91.36-2.7,1-.51-.36-.82-.33-1-1-1,.09-.27.15-1.21.42a4.86,4.86,0,0,0-1.67-.84v-.4c-1.09.09-1.81.7-2.75-.36-.06-.06-.46-.75-.55-.87-.76.21-.42.21-1,.6A1.59,1.59,0,0,0,63,4.3c-.33-.21-.09-.09-.42-.15l-1.15.09c-.15.06.3.09-.61.18v.64c.79.18.06,0,.58.24l.15.09s.06.06.12.06c.61.27.67,0,1.64,0a4.65,4.65,0,0,1,.39,1.87l-1.51.51a.3.3,0,0,1-.13.06l-1.84.22c-.79-.09-.52-.19-.82-.79-.15.06-.36.18-.55.27l-.51.3c-.61.46.3.19-.7.55a1.93,1.93,0,0,1-.94.09c0,.54,0,.51-.45,1.18s0,.6-1,.69c0,1.48.15.63.42,1.63l-.66.24c-1,.24-.55.24-.91,1.27s-.88.3-1.3,2.2c.66.46.81.46.93.88a1.5,1.5,0,0,1,.1.75c-2-.15-1.1.12-1.82-.06a7.7,7.7,0,0,0-2.3-.36c0,1.51-.06.48-.43.88l-.09.09-.3.48c0-1.42.3-.42.39-1.63-1.72-.48-1.66-2.32-3.42-2.63-1.42-.27,0-.42-1.51-.45-.37.76-.16.91-.82,1.42.21-1,.12-.3,0-.6-.76.18-.46.21-1,.6-.12-.94-.24-.79-1-.39.15.6,0,.42.6.6a2.4,2.4,0,0,0-.42,1.24l-1.21-1c-.55,1.06.12.7-.79,1.27l-.27.15a6,6,0,0,0-.61.42c.3,1.12.55.21.21,1-.69.09-.75.3-1.24.94,0,0-.06.06-.09.06a1,1,0,0,1-.15.18l-.33.3c-.31.27-.67.39-.76,1A1.8,1.8,0,0,0,37,22.08c-.45.55-.39.37-.42,1.24l-.91-.3c-.94-.21-.45.51-.73-.3h-1c0,1.39-.51,1.05-.21,1.66.21.39.76.51,1.24,1.2-.51.22-.18.16-.81,0,.09,1.09.24.37,0,1.45-.64-.45-.31-.33-1-1.66s-.76-.45-.64-1.84c-.85.24-.79.67-1.21,1.24l-1,1.06a3.6,3.6,0,0,0-.82,1.63c0,.6.37.93.37,2,.13.07.09.12.06.14a3.78,3.78,0,0,1,.54-.14c-.12.45,0,.24-.3.54l-.18.21c-.31.34-.12.12-.34.31l-.33.27-.12.09-.24.18c-.52.42-.4.48-.64,1l-.09.27c-1.24,3.26-2,3.26-5.66,4.65-.7.24,0,.15-.76.21-1,.09-.55-.49-1.39.09s-.16.48-.82,1c-1,.82-1.18-.33-3.12,1.63a1.66,1.66,0,0,1-1.27.52c-1.06,0-.28-.61-1.64.3-.09-1.09.21-.39-.39-.63-.19.66-.15.54-.7,1-1.24.94-.24-.27-2,1.69l-.21.21-.64.79s-.12.18-.18.24c-1,1.09-3.06.63-3.06,3.92h-.6a13.16,13.16,0,0,1-.22-2.26C4.37,46.41,4,48.2,4,49.4c.67.24.18-.33.54.52a2.8,2.8,0,0,1-.15,2.53A3.33,3.33,0,0,0,4,53.57v1.48c.06.48.18.33.67.9.57.76.15.76,1.06,1.82l.12.09c.24.3.27.39.51.72.82,1.06,1.15.51,1.15,3H7.07A3.32,3.32,0,0,0,4.8,58.85c0,1.9.51.64.63,2-.48-.3-.21-.24-.81-.39-.1,1.06.18.37-.43.61,1.33,2,3.42,2.74,3.94,5.31.21,1.15,1.42,1.75,1.85,2.72.24.54-.09.12.33.66.21.24.39.36.64.6a2.94,2.94,0,0,1,.69,1.79c.7,4.34,3.33,5.25,3.61,7.84l0,1.54c-.15.91.12.76.33,1.66s-.12,1.21-.3,1.91A4.58,4.58,0,0,1,14.1,85c0,1.48-.06,2.84,1.27,2.81,1.72,0,2.33,2.11,5.18,1.63.88-.15,2.36.06,3.15-.39s.91-1,1.21-1.3l.09-.09.3-.33.18-.21.61-.37c.49-.06,1.24,0,1.45-.72,0,0,0-.33,0-.39.31-1.15,1.94-1.12,3-1.48l2.37-.33c.18,0,.24,0,.48,0,.76-.06-.21-.12.55-.12l.3.09s.06,0,.09.06c.73.33-.55.18.76.27.18-.45.42-.7,1.72-.66.88,0,2.4.63,3.06-2.15a2,2,0,0,1,.4-1.06c.51-.6.84-.33,1.66-.81,3.27-1.9,2-2.23,5.73-2.29a10.92,10.92,0,0,0,3.93-1.21c2.43-1,2.18-1.66,5.94-1.66A9.47,9.47,0,0,0,59.92,74c.91-.16,2.73,1.29,3.43,1.75,1.18-.31.54-.85,2,.06.87.51,1.48.33,2.51.57.27.63.09,0,0,1,.66-.15.66-.27,1.24,0-.18.45-.39.3-.51.75L69,79.29c.51.45.91,0,1.42.63s.34.88,1.09,1.81a3.34,3.34,0,0,1,.67,2s-.09,0-.09,0-.09,0-.09,0l-.12,0-.52.54c1.24.12.91.91,2,1.18.4.06,0,0,.43.09,0,0,.06.09.42.18L74.1,85c-.15-.63.09-.81,1.21-2.23.76-1,2.18-1,2.76-2a5.08,5.08,0,0,1,.9-1.54c.52-.55.16.21.46-.58.12.14.1.1.09.09l.18.25a3.47,3.47,0,0,1,.33.48c-.6.06-.51.09-.81.39.42.94.45.82,0,1.39a4.83,4.83,0,0,0-1,3.23c0,1.21-.28.94-1.43.94-.18.75-.33.57-.42,1.45a4.56,4.56,0,0,0,1.45-.43c.88-.21,1,.49,1.46-.6L80,83.3l.4.64c0,.06,0,.12.06.15l.15.27a.23.23,0,0,1,.06.12c1.15,2.33-.76,2.39-.88,3.75a6.79,6.79,0,0,0,2.06-.4s.09,0,.12.09.09.06.12.09c1.28,1.09,2.64,2.51,2.06,4.38,0,0,0,.09,0,.12l-.06,1a3.64,3.64,0,0,0,.88,1.3l.85,1.38c.64.7,1.58.4,2.3,1.21l.58.67c.6-.22.6-.46,1.24-.28l.45.18a1.46,1.46,0,0,0,.19.07c.54.15.27,0,.78.24s2.09,1.18,2.27,1.63c1.16-.09,3.37-2.93,3.91-.82,1-.09,1.06-.72,1.88-.81l-.15.27c-.27.6-.15-.36-.27.75l1,.88.3.3.63.24a1.63,1.63,0,0,1,.37.85,1,1,0,0,0,.6-1.45c2.43,0,3.12-2.42,5.7-2.33,1.66.09,3,.58,4.18-.39l.42-.57c.3-.73,0-.91.12-1.54l1.09-3a4.05,4.05,0,0,1,2.18-2.66c.61-.51.16-.15.22-.54V89l.12-.54a4.17,4.17,0,0,1,1.12-2c1.21-1,.69-1.69,2.51-3.65l1.18-.66c.06,0,.09-.06.15-.06l.42-.31C121,80.36,120.78,78.94,120.5,77.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.82,29.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.79,42.81a22.14,22.14,0,0,0-2.09-2,31.34,31.34,0,0,0-3.17-2.07,6.15,6.15,0,0,0-1.61-.61,2.54,2.54,0,0,0-1,0,6.61,6.61,0,0,1,1.71-1.94,6.1,6.1,0,0,0,2.27-3c.35-1.2.69-2.39,1-3.58l-.12-.06c-.53.33-1,.66-1.58,1-1,.58-2,1.1-3,1.73a8.14,8.14,0,0,0-2.49,2.4,3.48,3.48,0,0,0-.49,2.5c.05.61-.29.62-.29.62a4.16,4.16,0,0,0-1.82,1.08c-.74.64-1.5,1.25-2.2,2a1.87,1.87,0,0,0-.55,1.1,3.38,3.38,0,0,1-.85,1.84,10,10,0,0,0-1.83,3.91q-.15.73.66.6a1.49,1.49,0,0,0,1.66.62c.08,0,.18-.07.23,0,1.07.52,1.57.43,2.56-.53a4.71,4.71,0,0,0,.69-.79c.5-.74,1.31-.81,2.06-1a6,6,0,0,0,2.54-1s.56-.47.82-.13a7.3,7.3,0,0,1,1,1.33,6,6,0,0,1,.47,1.95,12.48,12.48,0,0,0,.73,3.76,4,4,0,0,0,4.7,2.48,7.91,7.91,0,0,1,4.07.06c.26.09.5.22.8.34L71.19,55c-.26,0-.39,0-.51.32-.71,1.7-1.41,3.41-2.24,5-.54,1.06-1.32,2-2,3-.38.62-.93,1.32-.48,2a3.63,3.63,0,0,0,2.85,2c.7,0,1.4.09,2.1.1a3.27,3.27,0,0,0,2.42-1.79,1.16,1.16,0,0,0-.31-1.16c-.21.53-.6.61-1.06.66a2.49,2.49,0,0,0-.68.29c0-.46.44-.45.82-.57L72,64.1c-.13.09-.2.1-.24.15-.43.59-.68.68-1.37.46l-.57-.17c-.6-.19-.71-.13-.76.47,0,.13,0,.25,0,.46a1.26,1.26,0,0,1,.13-1.62c.76-1,1.54-1.91,2.39-2.79a31.94,31.94,0,0,0,4.84-6.44,3.72,3.72,0,0,0,.44-1.19A2.32,2.32,0,0,0,75.73,51a21.13,21.13,0,0,0-2.93-1.74,2,2,0,0,1-1.25-2.41l.25.78c.24.73.92.95,1.51,1.26.93.5,1.9.92,2.82,1.44,2,1.14,2.07,2.79.91,4.56-.51.78-1,1.59-1.48,2.39-.18.3-.18.48.27.57,1.65.3,3.28.76,4.94.94a25,25,0,0,0,4.06-.06c2.54-.13,4.92-1,7.37-1.56a11.18,11.18,0,0,1,4.35-.25,1.77,1.77,0,0,0,.3,0c-.09-.8-.17-1.56-.25-2.32s-.13-1.28-.19-1.93a15.55,15.55,0,0,0-1.52-6.28c-.19-.33-.42-.63-.67-1a3.89,3.89,0,0,1,1.42,1.27,7.33,7.33,0,0,1,1.15,3.12c.37,1.88.61,3.79.93,5.68a21.19,21.19,0,0,0,1.71,5.94,10.89,10.89,0,0,0,3.87,4.44C105.17,67,107.15,68,109.12,69c1.64.81,3.33,1.53,5,2.21,2.11.85,4.24,1.62,6.37,2.41,1,.38,2,.73,3.06,1.11a1.88,1.88,0,0,1,1.23,1.18L123.12,75l-.07.13c.17.59.38,1.17.5,1.77.31,1.59.6,3.2.87,4.8.22,1.25.43,2.5.59,3.75.09.69.08,1.39.12,2.09a4.46,4.46,0,0,0,1,2.89c.2.21.43.4.66.6a21.37,21.37,0,0,1,3.57,4.41,3.65,3.65,0,0,0,1.24,1.14h1c0-.1,0-.22-.05-.29a1.19,1.19,0,0,1-.12-1.57,4.26,4.26,0,0,0,.46-1.13c.15-.67-.32-1.14-.66-1.64-.12-.17-.27-.33-.41-.5L131,92.56l-.13-.06a1.92,1.92,0,0,0,.3-2.19,3.52,3.52,0,0,0-1.37-1.87,3.36,3.36,0,0,1-1.61-2.78c-.23-1.43-.36-2.88-.52-4.33a19.54,19.54,0,0,1-.18-2.52c0-1.22.26-2.43.34-3.65a2.72,2.72,0,0,0-.73-2,16.77,16.77,0,0,0-3.36-2.5c-2.12-1.47-4.26-2.92-6.28-4.53a29.21,29.21,0,0,1-6.89-7.88,9.37,9.37,0,0,1-1.16-3.53,6,6,0,0,1,.38-2.93,12.82,12.82,0,0,0,.7,5.13c1.1-.28,2.11-.7,2.28-1.92a7.43,7.43,0,0,0-.15-2.2c-.11-.68.25-1.07.92-.93a3.46,3.46,0,0,1,2.13,1.63c1.7,2.51,3.3,5.09,4.95,7.63,1,1.56,2,3.13,3,4.65,1.39,2,2.81,4.07,4.28,6a37.28,37.28,0,0,0,2.6,3c.81.88,1.68,1.71,2.54,2.54a33,33,0,0,0,13.43,7.64,54.06,54.06,0,0,0,5.88,1.28,27.1,27.1,0,0,0,4.93.29A35.56,35.56,0,0,0,162.5,86a29.16,29.16,0,0,0,7.78-2.68c1.2-.6,2.31-1.37,3.47-2.08A.45.45,0,0,0,174,81a7,7,0,0,0,.11-.8,1.57,1.57,0,0,0-.67-.06c-.62.22-1.22.49-1.82.77A35.36,35.36,0,0,1,165,83.33a31.37,31.37,0,0,1-4.6.88,36.16,36.16,0,0,1-5.1,0,21.46,21.46,0,0,1-8.74-2.5,25.71,25.71,0,0,1-5.88-4.09c-.66-.61-1.33-1.22-2-1.86A43.72,43.72,0,0,1,134,70.1,84.79,84.79,0,0,1,129.07,62c-1.1-2-2.18-4-3.29-6.07a58.68,58.68,0,0,0-5.36-8.41A35.92,35.92,0,0,0,116.2,43a24.25,24.25,0,0,0-11.7-5.66,34.77,34.77,0,0,0-4.32-.59c-2.47-.14-5-.26-7.42-.19A41.32,41.32,0,0,0,82.16,38a28.35,28.35,0,0,0-6.18,3,14.3,14.3,0,0,1-4.17,1.85,5.55,5.55,0,0,1-1.14.14,20.4,20.4,0,0,0-2.47.09Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.06,10.25H336.4V15h-1v-4.7h-1.66v-1h4.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.14,9.28V15h-1v-4l-1.88,2.89-1.86-2.89v4h-1V9.28h1.06L341.29,12l1.79-2.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.66,24v1.83a12.85,12.85,0,0,0-3.22-1.74,12,12,0,0,0-4.18-.68,12.54,12.54,0,0,0-4.87.93,12,12,0,0,0-3.87,2.58A11.83,11.83,0,0,0,170,30.74a12.46,12.46,0,0,0,0,9.35,11.78,11.78,0,0,0,6.42,6.41,12.54,12.54,0,0,0,4.87.93h.49a13.16,13.16,0,0,0,4.92-.92V40l0,0a6.75,6.75,0,0,1-2.25,1.44,7.35,7.35,0,0,1-2.64.48,8.06,8.06,0,0,1-1.12-.09h0a7.49,7.49,0,0,1-1.55-.39A6.25,6.25,0,0,1,176.84,40a6.12,6.12,0,0,1-2-4.61,6.19,6.19,0,0,1,2-4.65,7,7,0,0,1,2.24-1.42,7.32,7.32,0,0,1,2.67-.5,6.82,6.82,0,0,1,4.89,1.92,6.17,6.17,0,0,1,2,4.65v12h5.77V24Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.26,47.43,151.48,35.11V47.43h-5.77V15h5.77V27.23L164.26,15h8.17L155.56,31.17l16.87,16.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.42,23.39a10.61,10.61,0,0,1,4.28.84A9.94,9.94,0,0,1,217,26.56,10.71,10.71,0,0,1,219.1,30a11.67,11.67,0,0,1,.74,4.2V47.43h-5.76V34.2a4.85,4.85,0,0,0-1.68-3.78,5.5,5.5,0,0,0-3.94-1.56,5.56,5.56,0,0,0-4,1.56,5,5,0,0,0-1.63,3.78V47.43h-5.77V24h5.77v1.73a11.33,11.33,0,0,1,2.93-1.71A9.65,9.65,0,0,1,209.42,23.39Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.56,24a10.27,10.27,0,0,1,3.87-.69v5.48a6.86,6.86,0,0,0-4.9,1.92,6.36,6.36,0,0,0-2,4.65v12h-5.76V24h5.76v1.78A12.44,12.44,0,0,1,287.56,24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.48,23.39a12.92,12.92,0,0,1,9,3.51,12,12,0,0,1,2.71,3.84,11.53,11.53,0,0,1,0,9.35,11.92,11.92,0,0,1-2.71,3.83,12.58,12.58,0,0,1-4,2.58,13.61,13.61,0,0,1-9.89,0,12.58,12.58,0,0,1-4-2.58,11.92,11.92,0,0,1-2.71-3.83,11.53,11.53,0,0,1,0-9.35,12,12,0,0,1,2.71-3.84,12.92,12.92,0,0,1,9-3.51Zm0,5.47a6.86,6.86,0,0,0-4.91,1.92,6.19,6.19,0,0,0-2,4.65,6.12,6.12,0,0,0,2,4.61,6.25,6.25,0,0,0,2.24,1.44,7.52,7.52,0,0,0,2.67.48,7.35,7.35,0,0,0,2.64-.48A6.89,6.89,0,0,0,309.38,40a6.12,6.12,0,0,0,2-4.61,6.19,6.19,0,0,0-2-4.65A7.08,7.08,0,0,0,304.48,28.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.45,23.39a12.92,12.92,0,0,1,9,3.51,12.11,12.11,0,0,1,2.71,3.84,11.53,11.53,0,0,1,0,9.35,12.07,12.07,0,0,1-2.71,3.83,12.69,12.69,0,0,1-4,2.58,13.64,13.64,0,0,1-9.9,0,12.64,12.64,0,0,1-4-2.58,11.94,11.94,0,0,1-2.72-3.83,11.64,11.64,0,0,1,0-9.35,12,12,0,0,1,2.72-3.84,13,13,0,0,1,4-2.58A13.13,13.13,0,0,1,331.45,23.39Zm0,5.47a6.86,6.86,0,0,0-4.9,1.92,6.2,6.2,0,0,0-2,4.65,6.13,6.13,0,0,0,2,4.61,6.25,6.25,0,0,0,2.24,1.44,7.46,7.46,0,0,0,2.66.48,7.27,7.27,0,0,0,2.64-.48A6.69,6.69,0,0,0,336.35,40a6.1,6.1,0,0,0,2-4.61,6.17,6.17,0,0,0-2-4.65A7.06,7.06,0,0,0,331.45,28.86Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.79,24v1.83a13,13,0,0,0-3.21-1.74,12.05,12.05,0,0,0-4.18-.68,12.55,12.55,0,0,0-4.88.93,12,12,0,0,0-3.87,2.58,11.83,11.83,0,0,0-2.55,3.84,12.46,12.46,0,0,0,0,9.35,11.78,11.78,0,0,0,6.42,6.41,12.55,12.55,0,0,0,4.88.93h.48a13.16,13.16,0,0,0,4.92-.92V40l0,0a6.89,6.89,0,0,1-2.26,1.44,7.35,7.35,0,0,1-2.64.48,8.19,8.19,0,0,1-1.12-.09h0a7.49,7.49,0,0,1-1.55-.39,6.7,6.7,0,0,1-4.25-6,6.17,6.17,0,0,1,2-4.65,6.8,6.8,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5,6.86,6.86,0,0,1,4.9,1.92,6.19,6.19,0,0,1,2,4.65v12h5.77V24Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.85,24v1.83a12.85,12.85,0,0,0-3.22-1.74,11,11,0,0,0-2.09-.53,14.8,14.8,0,0,0-2.47-.2,12.06,12.06,0,0,0-4.78.94,11,11,0,0,0-3.75,2.58,11.8,11.8,0,0,0-2.43,3.83,12.62,12.62,0,0,0-.86,4.7v0a12,12,0,0,0,.91,4.66,11.8,11.8,0,0,0,6.41,6.41,12.59,12.59,0,0,0,4.88.93h.85a13,13,0,0,0,4.55-.91V40l0,0a6.69,6.69,0,0,1-2.26,1.44,7.27,7.27,0,0,1-2.64.48,8.32,8.32,0,0,1-1.12-.09h0a7.65,7.65,0,0,1-1.55-.39A6.7,6.7,0,0,1,228,35.41a6.41,6.41,0,0,1,.48-2.42,1.08,1.08,0,0,1,.08-.19,6.38,6.38,0,0,1,1.46-2,6.9,6.9,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5,6.84,6.84,0,0,1,4.9,1.92,6.38,6.38,0,0,1,1.46,2l.09.19a6.31,6.31,0,0,1,.47,2.44v9.13a6.11,6.11,0,0,1-2,4.61,7.08,7.08,0,0,1-8.36,1l-4.18,3.92a12.79,12.79,0,0,0,7.64,2.47,12.77,12.77,0,0,0,4.95-1,13.11,13.11,0,0,0,4-2.6,12.1,12.1,0,0,0,2.72-3.84,11.32,11.32,0,0,0,1-4.65V24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.41,67.27V68.8h-6.7V60.08h6.44v1.53h-4.72v2.22h3.95v1.48h-3.95v2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.47,59.36v9.33h-1.74v-.41a3.84,3.84,0,0,1-1.95.52,3.48,3.48,0,0,1,0-6.95,4,4,0,0,1,1.95.5v-3Zm-1.74,7.3V64a2.56,2.56,0,0,0-1.64-.57,1.93,1.93,0,0,0-2,1.94,1.89,1.89,0,0,0,2,1.91A2.48,2.48,0,0,0,161.73,66.66Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.46,62v6.73h-1.72v-.45a3.21,3.21,0,0,1-1.83.54c-2,0-2.87-.91-2.87-3.09V62h1.72v3.73c0,1,.51,1.55,1.46,1.55a2.25,2.25,0,0,0,1.52-.54V62Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.06,67.45a3.22,3.22,0,0,1-2.6,1.35,3.48,3.48,0,1,1,0-6.94,3.25,3.25,0,0,1,2.63,1.34l-1.12,1a1.83,1.83,0,0,0-1.51-.81,1.93,1.93,0,1,0,0,3.85,1.82,1.82,0,0,0,1.51-.83Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.1,62v6.73h-1.73v-.5a3.49,3.49,0,0,1-2,.59,3.48,3.48,0,0,1,0-6.95,4,4,0,0,1,2,.55V62Zm-1.73,2a2.55,2.55,0,0,0-1.66-.58,1.93,1.93,0,1,0,0,3.85,2.53,2.53,0,0,0,1.66-.57Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.84,63.41v2.37c0,1.2.2,1.55,1.07,1.55.3,0,.56,0,.79-.06v1.29a4.4,4.4,0,0,1-1.56.24,1.93,1.93,0,0,1-2-2.11V63.41h-1V62h1V59.37h1.73V62h1.89v1.43Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.84,60.35a1,1,0,1,1,2,0,1,1,0,1,1-2,0Zm.13,1.73h1.72V68.8H209Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.41,65.34a3.69,3.69,0,1,1-3.68-3.48A3.57,3.57,0,0,1,222.41,65.34Zm-1.7,0a2,2,0,1,0-2,1.92A1.95,1.95,0,0,0,220.71,65.34Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.13,65.05V68.8h-1.72V65.05c0-1-.51-1.54-1.46-1.54a2.19,2.19,0,0,0-1.49.53V68.8h-1.72V62.08h1.72v.42a3.19,3.19,0,0,1,1.8-.54C232.23,62,233.13,62.87,233.13,65.05Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.64,61.61v3.11h4.17v1.53h-4.17V68.8h-1.72V60.08h6.57v1.53Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.61,65.34a3.68,3.68,0,1,1-3.67-3.48A3.56,3.56,0,0,1,262.61,65.34Zm-1.69,0a2,2,0,0,0-4,0,2,2,0,0,0,4,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.3,62v6.73h-1.72v-.45a3.22,3.22,0,0,1-1.84.54c-2,0-2.87-.91-2.87-3.09V62h1.72v3.73c0,1,.51,1.55,1.46,1.55a2.3,2.3,0,0,0,1.53-.54V62Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.34,65.05V68.8h-1.72V65.05c0-1-.51-1.54-1.46-1.54a2.14,2.14,0,0,0-1.48.53V68.8H278V62.08h1.73v.42a3.13,3.13,0,0,1,1.79-.54C283.44,62,284.34,62.87,284.34,65.05Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.71,59.36v9.33H294v-.41a3.87,3.87,0,0,1-2,.52,3.48,3.48,0,0,1,0-6.95,4.07,4.07,0,0,1,2,.5v-3ZM294,66.66V64a2.59,2.59,0,0,0-1.65-.57,1.93,1.93,0,0,0-2,1.94,1.89,1.89,0,0,0,2,1.91A2.53,2.53,0,0,0,294,66.66Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.1,62v6.73h-1.72v-.5a3.55,3.55,0,0,1-2,.59,3.48,3.48,0,0,1,0-6.95,4,4,0,0,1,2,.55V62Zm-1.72,2a2.55,2.55,0,0,0-1.66-.58,1.93,1.93,0,1,0,0,3.85,2.53,2.53,0,0,0,1.66-.57Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.85,63.41v2.37c0,1.2.2,1.55,1.07,1.55.29,0,.55,0,.79-.06v1.29a4.53,4.53,0,0,1-1.56.24,1.93,1.93,0,0,1-2-2.11V63.41h-1V62h1V59.37h1.73V62h1.88v1.43Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.84,60.35a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1,319.84,60.35Zm.14,1.73h1.72V68.8H320Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.41,65.34a3.68,3.68,0,1,1-3.67-3.48A3.56,3.56,0,0,1,333.41,65.34Zm-1.69,0a2,2,0,1,0-2,1.92A1.95,1.95,0,0,0,331.72,65.34Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.14,65.05V68.8h-1.72V65.05c0-1-.51-1.54-1.47-1.54a2.16,2.16,0,0,0-1.48.53V68.8h-1.72V62.08h1.72v.42a3.13,3.13,0,0,1,1.79-.54C343.23,62,344.14,62.87,344.14,65.05Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.84,184.74c0-1.47.65-3.09,2.3-3.09s2.29,1.62,2.29,3.09-.65,3.11-2.29,3.11S341.84,186.2,341.84,184.74Zm3.83,0c0-1.2-.39-2.43-1.53-2.43s-1.53,1.23-1.53,2.43.38,2.44,1.53,2.44S345.67,185.94,345.67,184.74Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.91,117c0-1.47.65-3.1,2.3-3.1s2.29,1.63,2.29,3.1-.65,3.1-2.29,3.1S407.91,118.44,407.91,117Zm3.83,0c0-1.2-.39-2.43-1.53-2.43s-1.53,1.23-1.53,2.43.38,2.44,1.53,2.44S411.74,118.17,411.74,117Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.28,91.48v-5l-1,1-.45-.46,1.5-1.55H411v6Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.05,63v-.6c2.16-1.7,3.34-2.7,3.34-3.73a1.13,1.13,0,0,0-1.26-1.1,2,2,0,0,0-1.63.76l-.46-.48a2.58,2.58,0,0,1,2.09-.94,1.82,1.82,0,0,1,2,1.76c0,1.22-1.24,2.34-2.91,3.66h2.94V63Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,33.61l.44-.46a2.12,2.12,0,0,0,1.68.79c.87,0,1.4-.44,1.4-1.13s-.61-1.06-1.49-1.06h-.62v-.68H410c.75,0,1.39-.29,1.39-1s-.61-1-1.34-1a2,2,0,0,0-1.58.73l-.42-.47a2.6,2.6,0,0,1,2.06-.93c1.16,0,2,.59,2,1.6a1.44,1.44,0,0,1-1.29,1.39,1.53,1.53,0,0,1,1.39,1.49c0,1-.81,1.72-2.13,1.72A2.54,2.54,0,0,1,408,33.61Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.84,6V4.48H408V3.86L410.56,0h1V3.83h.84v.65h-.84V6Zm0-5.31-2.11,3.14h2.11Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.87,187.74v-5l-1,1-.45-.46,1.51-1.55h.65v6Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.28,187.74v-.6c2.16-1.7,3.34-2.7,3.34-3.73a1.12,1.12,0,0,0-1.26-1.1,2,2,0,0,0-1.63.76l-.45-.48a2.56,2.56,0,0,1,2.08-.94,1.82,1.82,0,0,1,2,1.76c0,1.22-1.24,2.34-2.92,3.66h3v.67Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.85,186.86l.44-.47a2.1,2.1,0,0,0,1.68.79c.87,0,1.4-.44,1.4-1.12s-.61-1.07-1.49-1.07h-.62v-.68h.62c.75,0,1.39-.3,1.39-1s-.61-1-1.34-1a2,2,0,0,0-1.58.73l-.42-.47a2.6,2.6,0,0,1,2.07-.92c1.15,0,2,.58,2,1.59a1.44,1.44,0,0,1-1.29,1.39,1.54,1.54,0,0,1,1.39,1.49c0,1-.81,1.73-2.13,1.73A2.54,2.54,0,0,1,256.85,186.86Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.38,187.74v-1.52h-2.85v-.62l2.57-3.87h1v3.83H233v.66h-.85v1.52Zm0-5.31-2.1,3.13h2.1Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.34,186.88l.46-.5a2,2,0,0,0,1.66.8,1.3,1.3,0,0,0,1.39-1.29,1.26,1.26,0,0,0-1.38-1.29,1.93,1.93,0,0,0-1.39.56l-.55-.19v-3.24h3.68v.67h-2.93v2.09a2,2,0,0,1,1.41-.54,1.83,1.83,0,0,1,1.91,1.92,2,2,0,0,1-2.14,2A2.46,2.46,0,0,1,200.34,186.88Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.86,184.74c0-1.62.76-3.09,2.45-3.09a2,2,0,0,1,1.65.72l-.37.55a1.54,1.54,0,0,0-1.28-.61c-1.17,0-1.69,1.18-1.69,2.36v.23a2.15,2.15,0,0,1,1.7-.93,1.81,1.81,0,0,1,2,1.92,2,2,0,0,1-2.1,2C172.5,187.85,171.86,186.38,171.86,184.74Zm3.66,1.17a1.23,1.23,0,0,0-1.37-1.29,1.82,1.82,0,0,0-1.51.89c.07.74.46,1.67,1.51,1.67A1.3,1.3,0,0,0,175.52,185.91Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.49,187.74l2.42-5.34h-3.24v-.67h4.1v.52l-2.46,5.49Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.22,186.22a1.79,1.79,0,0,1,1.43-1.58,1.57,1.57,0,0,1-1.33-1.44c0-1.08,1.05-1.55,2.05-1.55s2.06.47,2.06,1.55a1.59,1.59,0,0,1-1.34,1.44,1.79,1.79,0,0,1,1.43,1.58c0,1-1,1.63-2.15,1.63S115.22,187.24,115.22,186.22Zm3.54-.08c0-.79-1-1.12-1.39-1.16s-1.4.37-1.4,1.16.65,1,1.4,1S118.76,186.79,118.76,186.14Zm-.09-2.84c0-.62-.58-1-1.3-1s-1.3.37-1.3,1,.94,1,1.3,1S118.67,184,118.67,183.3Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.12,187.12l.38-.56a1.53,1.53,0,0,0,1.28.61c1.22,0,1.7-1.21,1.7-2.36a1.85,1.85,0,0,0,0-.23,2.17,2.17,0,0,1-1.7.94,1.82,1.82,0,0,1-2-1.92,2,2,0,0,1,2.11-2c1.67,0,2.32,1.46,2.32,3.1s-.76,3.1-2.45,3.1A2.12,2.12,0,0,1,87.12,187.12ZM90.45,184c-.07-.74-.47-1.67-1.51-1.67a1.31,1.31,0,0,0-1.38,1.27,1.25,1.25,0,0,0,1.39,1.3A1.84,1.84,0,0,0,90.45,184Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58,187.74v-5l-1,1-.45-.46,1.51-1.55h.66v6Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.91,184.74c0-1.47.64-3.09,2.29-3.09s2.3,1.62,2.3,3.09-.66,3.11-2.3,3.11S59.91,186.2,59.91,184.74Zm3.82,0c0-1.2-.39-2.43-1.53-2.43s-1.53,1.23-1.53,2.43.39,2.44,1.53,2.44S63.73,185.94,63.73,184.74Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.88,187.74v-5l-1,1-.45-.46,1.5-1.55h.66v6Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.93,187.74v-5l-1,1-.45-.46,1.5-1.55h.66v6Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.41,187.74v-5l-1,1L0,183.28l1.5-1.55h.66v6Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.35,187.74v-.6c2.16-1.7,3.34-2.7,3.34-3.73a1.13,1.13,0,0,0-1.26-1.1,2,2,0,0,0-1.63.76l-.46-.48a2.58,2.58,0,0,1,2.09-.94,1.82,1.82,0,0,1,2,1.76c0,1.22-1.24,2.34-2.91,3.66H7.47v.67Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 3.61,
    x2: 344.14,
    y2: 173.63
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 341.3,
    y1: 116.94,
    x2: 341.3,
    y2: 145.29
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 338.47,
    y1: 116.94,
    x2: 338.47,
    y2: 145.29
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 335.63,
    y1: 116.94,
    x2: 335.63,
    y2: 145.29
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 332.8,
    y1: 116.94,
    x2: 332.8,
    y2: 145.29
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 329.96,
    y1: 116.94,
    x2: 329.96,
    y2: 159.46
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 327.13,
    y1: 116.94,
    x2: 327.13,
    y2: 145.29
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 324.29,
    y1: 116.94,
    x2: 324.29,
    y2: 145.29
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 321.46,
    y1: 116.94,
    x2: 321.46,
    y2: 145.29
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 318.63,
    y1: 116.94,
    x2: 318.63,
    y2: 145.29
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 315.79,
    y1: 116.94,
    x2: 315.79,
    y2: 173.63
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 312.96,
    y1: 116.94,
    x2: 312.96,
    y2: 145.29
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 310.12,
    y1: 116.94,
    x2: 310.12,
    y2: 145.29
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 307.29,
    y1: 116.94,
    x2: 307.29,
    y2: 145.29
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 304.45,
    y1: 116.94,
    x2: 304.45,
    y2: 145.29
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 301.62,
    y1: 116.94,
    x2: 301.62,
    y2: 159.46
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 298.78,
    y1: 116.94,
    x2: 298.78,
    y2: 145.29
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 295.95,
    y1: 116.94,
    x2: 295.95,
    y2: 145.29
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 293.11,
    y1: 116.94,
    x2: 293.11,
    y2: 145.29
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 290.28,
    y1: 116.94,
    x2: 290.28,
    y2: 145.29
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 287.44,
    y1: 116.94,
    x2: 287.44,
    y2: 173.63
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.61,
    y1: 116.94,
    x2: 284.61,
    y2: 145.29
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 281.77,
    y1: 116.94,
    x2: 281.77,
    y2: 145.29
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 278.94,
    y1: 116.94,
    x2: 278.94,
    y2: 145.29
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 276.11,
    y1: 116.94,
    x2: 276.11,
    y2: 145.29
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 273.27,
    y1: 116.94,
    x2: 273.27,
    y2: 159.46
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 270.44,
    y1: 116.94,
    x2: 270.44,
    y2: 145.29
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 267.6,
    y1: 116.94,
    x2: 267.6,
    y2: 145.29
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 264.77,
    y1: 116.94,
    x2: 264.77,
    y2: 145.29
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 261.93,
    y1: 116.94,
    x2: 261.93,
    y2: 145.29
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.1,
    y1: 116.94,
    x2: 259.1,
    y2: 173.63
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 256.26,
    y1: 116.94,
    x2: 256.26,
    y2: 145.29
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 253.43,
    y1: 116.94,
    x2: 253.43,
    y2: 145.29
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 250.59,
    y1: 116.94,
    x2: 250.59,
    y2: 145.29
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 247.76,
    y1: 116.94,
    x2: 247.76,
    y2: 145.29
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 244.92,
    y1: 116.94,
    x2: 244.92,
    y2: 159.46
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 242.09,
    y1: 116.94,
    x2: 242.09,
    y2: 145.29
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 239.26,
    y1: 116.94,
    x2: 239.26,
    y2: 145.29
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 236.42,
    y1: 116.94,
    x2: 236.42,
    y2: 145.29
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 233.59,
    y1: 116.94,
    x2: 233.59,
    y2: 145.29
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 230.75,
    y1: 116.94,
    x2: 230.75,
    y2: 173.63
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 227.92,
    y1: 116.94,
    x2: 227.92,
    y2: 145.29
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 225.08,
    y1: 116.94,
    x2: 225.08,
    y2: 145.29
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 222.25,
    y1: 116.94,
    x2: 222.25,
    y2: 145.29
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 219.41,
    y1: 116.94,
    x2: 219.41,
    y2: 145.29
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.58,
    y1: 116.94,
    x2: 216.58,
    y2: 159.46
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 213.74,
    y1: 116.94,
    x2: 213.74,
    y2: 145.29
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 210.91,
    y1: 116.94,
    x2: 210.91,
    y2: 145.29
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 208.07,
    y1: 116.94,
    x2: 208.07,
    y2: 145.29
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 205.24,
    y1: 116.94,
    x2: 205.24,
    y2: 145.29
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 202.4,
    y1: 116.94,
    x2: 202.4,
    y2: 173.63
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 199.57,
    y1: 116.94,
    x2: 199.57,
    y2: 145.29
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 196.74,
    y1: 116.94,
    x2: 196.74,
    y2: 145.29
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 193.9,
    y1: 116.94,
    x2: 193.9,
    y2: 145.29
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191.07,
    y1: 116.94,
    x2: 191.07,
    y2: 145.29
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 188.23,
    y1: 116.94,
    x2: 188.23,
    y2: 159.46
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 185.4,
    y1: 116.94,
    x2: 185.4,
    y2: 145.29
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 182.56,
    y1: 116.94,
    x2: 182.56,
    y2: 145.29
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 179.73,
    y1: 116.94,
    x2: 179.73,
    y2: 145.29
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 176.89,
    y1: 116.94,
    x2: 176.89,
    y2: 145.29
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 174.06,
    y1: 116.94,
    x2: 174.06,
    y2: 173.63
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 171.22,
    y1: 116.94,
    x2: 171.22,
    y2: 145.29
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 168.39,
    y1: 116.94,
    x2: 168.39,
    y2: 145.29
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.55,
    y1: 116.94,
    x2: 165.55,
    y2: 145.29
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 162.72,
    y1: 116.94,
    x2: 162.72,
    y2: 145.29
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 159.89,
    y1: 116.94,
    x2: 159.89,
    y2: 159.46
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 157.05,
    y1: 116.94,
    x2: 157.05,
    y2: 145.29
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 154.22,
    y1: 116.94,
    x2: 154.22,
    y2: 145.29
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.38,
    y1: 116.94,
    x2: 151.38,
    y2: 145.29
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.55,
    y1: 116.94,
    x2: 148.55,
    y2: 145.29
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145.71,
    y1: 116.94,
    x2: 145.71,
    y2: 173.63
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 142.88,
    y1: 116.94,
    x2: 142.88,
    y2: 145.29
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.04,
    y1: 116.94,
    x2: 140.04,
    y2: 145.29
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 137.21,
    y1: 116.94,
    x2: 137.21,
    y2: 145.29
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.37,
    y1: 116.94,
    x2: 134.37,
    y2: 145.29
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 131.54,
    y1: 116.94,
    x2: 131.54,
    y2: 159.46
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 128.7,
    y1: 116.94,
    x2: 128.7,
    y2: 145.29
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 125.87,
    y1: 116.94,
    x2: 125.87,
    y2: 145.29
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 123.03,
    y1: 116.94,
    x2: 123.03,
    y2: 145.29
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 120.2,
    y1: 116.94,
    x2: 120.2,
    y2: 145.29
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 117.37,
    y1: 116.94,
    x2: 117.37,
    y2: 173.63
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.53,
    y1: 116.94,
    x2: 114.53,
    y2: 145.29
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 111.7,
    y1: 116.94,
    x2: 111.7,
    y2: 145.29
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 108.86,
    y1: 116.94,
    x2: 108.86,
    y2: 145.29
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 106.03,
    y1: 116.94,
    x2: 106.03,
    y2: 145.29
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.19,
    y1: 116.94,
    x2: 103.19,
    y2: 159.46
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 100.36,
    y1: 116.94,
    x2: 100.36,
    y2: 145.29
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.52,
    y1: 116.94,
    x2: 97.52,
    y2: 145.29
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 94.69,
    y1: 116.94,
    x2: 94.69,
    y2: 145.29
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.85,
    y1: 116.94,
    x2: 91.85,
    y2: 145.29
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 89.02,
    y1: 116.94,
    x2: 89.02,
    y2: 173.63
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 86.18,
    y1: 116.94,
    x2: 86.18,
    y2: 145.29
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 83.35,
    y1: 116.94,
    x2: 83.35,
    y2: 145.29
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.52,
    y1: 116.94,
    x2: 80.52,
    y2: 145.29
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.68,
    y1: 116.94,
    x2: 77.68,
    y2: 145.29
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 74.85,
    y1: 116.94,
    x2: 74.85,
    y2: 159.46
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.01,
    y1: 116.94,
    x2: 72.01,
    y2: 145.29
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.18,
    y1: 116.94,
    x2: 69.18,
    y2: 145.29
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.34,
    y1: 116.94,
    x2: 66.34,
    y2: 145.29
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 63.51,
    y1: 116.94,
    x2: 63.51,
    y2: 145.29
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 60.67,
    y1: 116.94,
    x2: 60.67,
    y2: 173.63
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.84,
    y1: 116.94,
    x2: 57.84,
    y2: 145.29
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55,
    y1: 116.94,
    x2: 55,
    y2: 145.29
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 52.17,
    y1: 116.94,
    x2: 52.17,
    y2: 145.29
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 49.33,
    y1: 116.94,
    x2: 49.33,
    y2: 145.29
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 46.5,
    y1: 116.94,
    x2: 46.5,
    y2: 159.46
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 43.66,
    y1: 116.94,
    x2: 43.66,
    y2: 145.29
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 40.83,
    y1: 116.94,
    x2: 40.83,
    y2: 145.29
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38,
    y1: 116.94,
    x2: 38,
    y2: 145.29
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 35.16,
    y1: 116.94,
    x2: 35.16,
    y2: 145.29
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.33,
    y1: 116.94,
    x2: 32.33,
    y2: 173.63
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29.49,
    y1: 116.94,
    x2: 29.49,
    y2: 145.29
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.66,
    y1: 116.94,
    x2: 26.66,
    y2: 145.29
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.82,
    y1: 116.94,
    x2: 23.82,
    y2: 145.29
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.99,
    y1: 116.94,
    x2: 20.99,
    y2: 145.29
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 18.15,
    y1: 116.94,
    x2: 18.15,
    y2: 159.46
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 15.32,
    y1: 116.94,
    x2: 15.32,
    y2: 145.29
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 12.48,
    y1: 116.94,
    x2: 12.48,
    y2: 145.29
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 9.65,
    y1: 116.94,
    x2: 9.65,
    y2: 145.29
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6.81,
    y1: 116.94,
    x2: 6.81,
    y2: 145.29
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3.98,
    y1: 3.61,
    x2: 3.98,
    y2: 173.63
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145.71,
    y1: 3.61,
    x2: 145.71,
    y2: 4.61
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.71,
    y1: 6.63,
    x2: 145.71,
    y2: 114.93
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145.71,
    y1: 115.94,
    x2: 145.71,
    y2: 116.94
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3.98,
    y1: 3.61,
    x2: 400.83,
    y2: 3.61
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 6.44,
    x2: 372.48,
    y2: 6.44
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 9.28,
    x2: 372.48,
    y2: 9.28
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 12.11,
    x2: 372.48,
    y2: 12.11
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 14.95,
    x2: 372.48,
    y2: 14.95
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 17.78,
    x2: 386.66,
    y2: 17.78
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 20.62,
    x2: 372.48,
    y2: 20.62
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 23.45,
    x2: 372.48,
    y2: 23.45
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 26.28,
    x2: 372.48,
    y2: 26.28
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 29.12,
    x2: 372.48,
    y2: 29.12
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 31.95,
    x2: 400.83,
    y2: 31.95
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 34.79,
    x2: 372.48,
    y2: 34.79
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 37.62,
    x2: 372.48,
    y2: 37.62
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 40.46,
    x2: 372.48,
    y2: 40.46
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 43.29,
    x2: 372.48,
    y2: 43.29
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 46.13,
    x2: 386.66,
    y2: 46.13
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 48.96,
    x2: 372.48,
    y2: 48.96
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 51.8,
    x2: 372.48,
    y2: 51.8
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 54.63,
    x2: 372.48,
    y2: 54.63
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 57.47,
    x2: 372.48,
    y2: 57.47
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 60.3,
    x2: 400.83,
    y2: 60.3
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 63.14,
    x2: 372.48,
    y2: 63.14
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 65.97,
    x2: 372.48,
    y2: 65.97
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 68.8,
    x2: 372.48,
    y2: 68.8
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 71.64,
    x2: 372.48,
    y2: 71.64
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 74.47,
    x2: 386.66,
    y2: 74.47
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 77.31,
    x2: 372.48,
    y2: 77.31
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 80.14,
    x2: 372.48,
    y2: 80.14
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 82.98,
    x2: 372.48,
    y2: 82.98
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 85.81,
    x2: 372.48,
    y2: 85.81
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 88.65,
    x2: 400.83,
    y2: 88.65
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 91.48,
    x2: 372.48,
    y2: 91.48
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 94.32,
    x2: 372.48,
    y2: 94.32
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 97.15,
    x2: 372.48,
    y2: 97.15
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 99.99,
    x2: 372.48,
    y2: 99.99
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 102.82,
    x2: 386.66,
    y2: 102.82
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 105.65,
    x2: 372.48,
    y2: 105.65
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 108.49,
    x2: 372.48,
    y2: 108.49
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 111.32,
    x2: 372.48,
    y2: 111.32
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 344.14,
    y1: 114.16,
    x2: 372.48,
    y2: 114.16
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3.98,
    y1: 116.99,
    x2: 400.83,
    y2: 116.99
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145.71,
    y1: 9.28,
    x2: 146.71,
    y2: 9.28
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 148.7,
    y1: 9.28,
    x2: 342.15,
    y2: 9.28
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 343.14,
    y1: 9.28,
    x2: 344.14,
    y2: 9.28
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145.71,
    y1: 14.95,
    x2: 146.71,
    y2: 14.95
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 148.7,
    y1: 14.95,
    x2: 342.15,
    y2: 14.95
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 343.14,
    y1: 14.95,
    x2: 344.14,
    y2: 14.95
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 145.71,
    y1: 68.8,
    x2: 146.71,
    y2: 68.8
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 148.69,
    y1: 68.8,
    x2: 342.02,
    y2: 68.8
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 343.01,
    y1: 68.8,
    x2: 344.01,
    y2: 68.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPls1);
export default __webpack_public_path__ + "static/media/pls1.26baa86cddf957343c73ff2d5b449ee4.svg";
export { ForwardRef as ReactComponent };